module.exports = __webpack_public_path__ + "static/media/gzr.a57dd02b.svg";